/* PureVie Bio — système d'avis maison (données : avis.json dans les assets) */
(function () {
  'use strict';

  var url = document.documentElement.getAttribute('data-avis-url');
  if (!url) return;

  var PAGE = 8;

  function stars(note) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= Math.round(note) ? '★' : '☆';
    return s;
  }
  function dateFr(iso) {
    try {
      return new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(iso));
    } catch (e) { return iso; }
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // 1. Ligne de note dans le héro (et partout où [data-rating-top] existe)
      document.querySelectorAll('[data-rating-top]').forEach(function (el) {
        el.innerHTML =
          '<span class="rt-stars" aria-hidden="true">★★★★★</span>' +
          '<strong>' + String(data.moyenne).replace('.', ',') + '</strong>' +
          '<span class="rt-sep">·</span><a href="#avis">' + data.total + ' avis</a>';
      });

      // 2. Widget complet
      var widget = document.querySelector('[data-avis-widget]');
      if (!widget) return;

      var summary = widget.querySelector('[data-avis-summary]');
      var listEl = widget.querySelector('[data-avis-list]');
      var moreBtn = widget.querySelector('[data-avis-more]');
      var lessBtn = widget.querySelector('[data-avis-less]');
      var shown = 0;

      // Résumé + histogramme
      var bars = '';
      for (var i = 0; i < 5; i++) {
        var n = 5 - i;
        var count = data.repartition[i];
        var pct = data.total ? Math.round((count / data.total) * 100) : 0;
        bars +=
          '<div class="av-bar"><span class="av-bar__label">' + n + ' ★</span>' +
          '<span class="av-bar__track"><span class="av-bar__fill" style="width:' + pct + '%"></span></span>' +
          '<span class="av-bar__count">' + count + '</span></div>';
      }
      summary.innerHTML =
        '<div class="av-score"><span class="av-score__num">' + String(data.moyenne).replace('.', ',') + '</span>' +
        '<span class="av-score__stars">' + stars(data.moyenne) + '</span>' +
        '<span class="av-score__total">' + data.total + ' avis</span></div>' +
        '<div class="av-bars">' + bars + '</div>';

      function card(a) {
        var photo = a.photo
          ? '<a class="av-card__photo" href="' + widget.getAttribute('data-asset-base').replace('AVISJSON', a.photo) + '" target="_blank" rel="noopener">' +
            '<img src="' + widget.getAttribute('data-asset-base').replace('AVISJSON', a.photo) + '" alt="Photo client" loading="lazy" width="140" height="140"></a>'
          : '';
        return '<div class="av-card">' + photo +
          '<div class="av-card__content">' +
          '<div class="av-card__head"><span class="av-card__stars">' + stars(a.note) + '</span>' +
          '<span class="av-card__name">' + esc(a.nom) + '</span>' +
          '<span class="av-card__date">' + dateFr(a.date) + '</span></div>' +
          (a.titre ? '<p class="av-card__title">' + esc(a.titre) + '</p>' : '') +
          '<p class="av-card__text">' + esc(a.texte) + '</p>' +
          '</div></div>';
      }

      function syncButtons() {
        if (moreBtn) {
          moreBtn.style.display = shown >= data.avis.length ? 'none' : '';
          moreBtn.textContent = 'Voir plus d’avis';
        }
        // "Voir moins" visible dès qu'on a dépassé la première page
        if (lessBtn) lessBtn.style.display = shown > PAGE ? '' : 'none';
      }
      function renderMore() {
        var next = data.avis.slice(shown, shown + PAGE);
        listEl.insertAdjacentHTML('beforeend', next.map(card).join(''));
        shown += next.length;
        syncButtons();
      }
      function renderLess() {
        // Replie à la première page et remonte en haut de la liste
        shown = 0;
        listEl.innerHTML = '';
        renderMore();
        var top = listEl.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      renderMore();
      if (moreBtn) moreBtn.addEventListener('click', renderMore);
      if (lessBtn) lessBtn.addEventListener('click', renderLess);

      // 3. Formulaire "Écrire un avis"
      var toggle = widget.querySelector('[data-avis-form-toggle]');
      var formWrap = widget.querySelector('[data-avis-form]');
      if (toggle && formWrap) {
        toggle.addEventListener('click', function () {
          var open = formWrap.classList.toggle('is-open');
          toggle.textContent = open ? 'Fermer' : '✉ Écrire un avis';
          if (open) formWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      // Étoiles cliquables du formulaire
      var picker = widget.querySelector('[data-note-picker]');
      if (picker) {
        var input = widget.querySelector('input[name="contact[Note]"]');
        var btns = picker.querySelectorAll('button');
        btns.forEach(function (b, idx) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            input.value = (idx + 1) + '/5';
            btns.forEach(function (x, j) { x.classList.toggle('is-on', j <= idx); });
          });
        });
      }
    })
    .catch(function () { /* silencieux : la section garde son état de base */ });
})();
